export enum MODALS_TYPES {
    CONTINUE_MODAL,
    EVENT_DETAILS_MODAL,
    EVENT_LIVE_DETAILS_MODAL,
    PLAYER_DETAILS_MODAL,
    PLAYER_MARKET_MODAL,
    BOOK_EVENT_MODAL,
    BOOK_EXTRA_MODAL,
    BOOK_PLAYER_MODAL,
    BOOK_LIVE_MODAL,
    SIGN_CHART_MODAL,
    HIDE_ALERT_MODAL,
    HIDE_EXTRA_MODAL,
    HIDE_PLAYER_MODAL,
    HIDE_LIVE_MODAL,
    EXTRA_DETAILS_MODAL
}